import React from 'react';
import { Alert } from 'reactstrap';

const AlertV2 = ({ children, className, title, style, ...props }) => {
  return (
    <Alert
      className={`border-0 px-2 py-1 ${className}`}
      style={{ ...style }}
      {...props}
    >
      <h5 className="fw-medium mb-0" style={{ fontSize: 14 }}>
        {title}
      </h5>
      <span style={{ fontSize: 12 }}>{children}</span>
    </Alert>
  );
};

export default AlertV2;
